import { useState } from 'react';
import { motion } from 'framer-motion';
import { Trash2, Plus, Edit, Download, Upload } from 'lucide-react';
import * as XLSX from 'xlsx';
import { StringerAllocationSettings } from './StringerAllocationSettings';

export const customerFieldLabels: Record<string, string> = {
  numericId: 'ID TechTennis (Automático)',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  gender: 'Gênero',
  phone: 'Celular',
  originClub: 'Clube de Origem',
  professorId: 'Professor / Treinador',
  email: 'E-mail',
  birthDate: 'Data de Nascimento',
  cpfCnpj: 'CPF/CNPJ',
  cep: 'CEP',
  address: 'Endereço',
  addressNumber: 'Número',
  complement: 'Complemento',
  neighborhood: 'Bairro',
  city: 'Cidade',
  state: 'Estado',
  country: 'País',
  stringingPoint: 'Ponto de Encordoamento Base',
  notes: 'Observações'
};

export const professorFieldLabels: Record<string, string> = {
  numericId: 'ID TechTennis (Automático)',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  cpfCnpj: 'CPF/CNPJ',
  birthDate: 'Data de Nascimento',
  gender: 'Gênero',
  phone: 'Celular',
  email: 'Email',
  cep: 'CEP',
  address: 'Endereço',
  addressNumber: 'Número',
  complement: 'Complemento',
  neighborhood: 'Bairro',
  city: 'Cidade',
  state: 'Estado',
  country: 'País',
  yearsOfExperience: 'Anos de Experiência',
  trainingTypes: 'Tipos de Treinamento'
};

export const SettingsView = ({ settings, setSettings }: any) => {
  const [activeTab, setActiveTab] = useState<'strings' | 'pickupPoints' | 'machines' | 'stringers' | 'stringerAllocation' | 'sports' | 'clubs' | 'commissions' | 'clubDiscounts' | 'stringingPrices' | 'racketModels' | 'customerFields' | 'professorFields'>('strings');
  const [newItemText, setNewItemText] = useState('');
  const [newCommissionPercent, setNewCommissionPercent] = useState('');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editItemText, setEditItemText] = useState('');
  const [editCommissionPercent, setEditCommissionPercent] = useState('');
  const [newStringPrice, setNewStringPrice] = useState('');
  const [editStringPrice, setEditStringPrice] = useState('');
  const [newStringerEmail, setNewStringerEmail] = useState('');
  const [editStringerEmail, setEditStringerEmail] = useState('');
  const [newStringSku, setNewStringSku] = useState('');
  const [newStringType, setNewStringType] = useState('');
  const [editStringSku, setEditStringSku] = useState('');
  const [editStringType, setEditStringType] = useState('');
  const [newStringBrand, setNewStringBrand] = useState('');
  const [editStringBrand, setEditStringBrand] = useState('');
  const [newStringShortDescription, setNewStringShortDescription] = useState('');
  const [editStringShortDescription, setEditStringShortDescription] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [newStringingPriceType, setNewStringingPriceType] = useState('Multifilamento');
  const [newStringingPriceValue, setNewStringingPriceValue] = useState('');
  const [editStringingPriceType, setEditStringingPriceType] = useState('Multifilamento');
  const [editStringingPriceValue, setEditStringingPriceValue] = useState('');

  const [newClub, setNewClub] = useState('');
  const [newDiscountService, setNewDiscountService] = useState('');
  const [newDiscountPercent, setNewDiscountPercent] = useState('');
  const [newDiscountValue, setNewDiscountValue] = useState('');
  const [newStartDate, setNewStartDate] = useState('');
  const [newEndDate, setNewEndDate] = useState('');

  const [editClub, setEditClub] = useState('');
  const [editDiscountService, setEditDiscountService] = useState('');
  const [editDiscountPercent, setEditDiscountPercent] = useState('');
  const [editDiscountValue, setEditDiscountValue] = useState('');
  const [editStartDate, setEditStartDate] = useState('');
  const [editEndDate, setEditEndDate] = useState('');

  const currentList = settings[activeTab] || [];
  const uniqueClubs = settings.clubs || [];

  const handleAdd = () => {
    let value: any = newItemText.trim();
    if (activeTab === 'commissions') {
      if (!newItemText.trim()) return;
      value = { name: newItemText.trim(), percent: Number(newCommissionPercent) || 0 };
    } else if (activeTab === 'strings') {
      if (!newItemText.trim()) return;
      value = { name: newItemText.trim(), sku: newStringSku.trim(), shortDescription: newStringShortDescription.trim(), price: Number(newStringPrice) || 0, type: newStringType || 'Monofilamento', brand: newStringBrand.trim() || 'Desconhecida' };
        setNewStringSku('');
    } else if (activeTab === 'stringers') {
      if (!newItemText.trim()) return;
      value = { name: newItemText.trim(), email: newStringerEmail.trim() };
      setNewStringerEmail('');
    } else if (activeTab === 'clubDiscounts') {
      if (!newClub || !newDiscountService || (!newDiscountPercent && !newDiscountValue)) return;
      value = { club: newClub, service: newDiscountService, percent: Number(newDiscountPercent) || 0, value: Number(newDiscountValue) || 0, startDate: newStartDate, endDate: newEndDate };
    } else if (activeTab === 'stringingPrices') {
      if (!newStringingPriceValue) return;
      value = { type: newStringingPriceType, price: Number(newStringingPriceValue) || 0 };
    } else {
      if (!newItemText.trim()) return;
      if (currentList.some((item: any) => typeof item === 'string' && item.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() === value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())) {
        alert('Atenção: Este item já existe na lista!');
        return;
      }
    }

    setSettings((prev: any) => ({
      ...prev,
      [activeTab]: [...(prev[activeTab] || []), value]
    }));
    setNewItemText('');
    setNewCommissionPercent('');
    setNewStringPrice('');
    setNewStringType('');
    setNewStringBrand('');
    setNewStringShortDescription('');
    setNewClub('');
    setNewDiscountService('');
    setNewDiscountPercent('');
    setNewDiscountValue('');
    setNewStartDate('');
    setNewEndDate('');
    setNewStringingPriceValue('');
  };

  const [itemsPerPage, setItemsPerPage] = useState<number | 'all'>(10);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Update handleTabChange to reset pagination
  const handleTabChange = (tabId: any) => {
    setActiveTab(tabId);
    setEditingIndex(null);
    setNewItemText('');
    setSearchQuery('');
    setCurrentPage(1);
  };

  const handleDelete = (index: number) => {
    setSettings((prev: any) => {
      const newList = [...(prev[activeTab] || [])];
      newList.splice(index, 1);
      return { ...prev, [activeTab]: newList };
    });
  };

  const handleEdit = (index: number) => {
    setEditingIndex(index);
    if (activeTab === 'commissions') {
      setEditItemText(currentList[index].name);
      setEditCommissionPercent(currentList[index].percent.toString());
    } else if (activeTab === 'strings') {
      const str = currentList[index];
      if (typeof str === 'string') {
        setEditItemText(str);
        setEditStringPrice('0');
        setEditStringType('Monofilamento');
      } else {
        setEditItemText(str.name);
        setEditStringSku(str.sku || '');
        setEditStringPrice(str.price.toString());
        setEditStringType(str.type || 'Monofilamento');
        setEditStringBrand(str.brand || 'Desconhecida');
        setEditStringShortDescription(str.shortDescription || '');
      }
    } else if (activeTab === 'stringers') {
      const str = currentList[index];
      if (typeof str === 'string') {
        setEditItemText(str);
        setEditStringerEmail('');
      } else {
        setEditItemText(str.name);
        setEditStringerEmail(str.email || '');
      }
    } else if (activeTab === 'clubDiscounts') {
      setEditClub(currentList[index].club);
      setEditDiscountService(currentList[index].service);
      setEditDiscountPercent(currentList[index].percent?.toString() || '');
      setEditDiscountValue(currentList[index].value?.toString() || '');
      setEditStartDate(currentList[index].startDate || '');
      setEditEndDate(currentList[index].endDate || '');
    } else if (activeTab === 'stringingPrices') {
      setEditStringingPriceType(currentList[index].type || 'Multifilamento');
      setEditStringingPriceValue(currentList[index].price?.toString() || '0');
    } else {
      setEditItemText(currentList[index]);
    }
  };

  const saveEdit = (index: number) => {
    setSettings((prev: any) => {
      const newList = [...(prev[activeTab] || [])];
      if (activeTab === 'commissions') {
         if (!editItemText.trim()) return prev;
         newList[index] = { name: editItemText.trim(), percent: Number(editCommissionPercent) || 0 };
      } else if (activeTab === 'strings') {
         if (!editItemText.trim()) return prev;
         newList[index] = { name: editItemText.trim(), sku: editStringSku.trim(), shortDescription: editStringShortDescription.trim(), price: Number(editStringPrice) || 0, type: editStringType || 'Monofilamento', brand: editStringBrand.trim() || 'Desconhecida' };
      } else if (activeTab === 'stringers') {
         if (!editItemText.trim()) return prev;
         newList[index] = { name: editItemText.trim(), email: editStringerEmail.trim() };
      } else if (activeTab === 'clubDiscounts') {
         if (!editClub.trim() || !editDiscountService || (!editDiscountPercent && !editDiscountValue)) return prev;
         newList[index] = { club: editClub.trim(), service: editDiscountService, percent: Number(editDiscountPercent) || 0, value: Number(editDiscountValue) || 0, startDate: editStartDate, endDate: editEndDate };
      } else if (activeTab === 'stringingPrices') {
         if (!editStringingPriceValue) return prev;
         newList[index] = { type: editStringingPriceType, price: Number(editStringingPriceValue) || 0 };
      } else {
         if (!editItemText.trim()) return prev;
         if (newList.some((item: any, i: number) => i !== index && typeof item === 'string' && item.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() === editItemText.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())) {
           alert('Atenção: Este item já existe na lista!');
           return prev;
         }
         newList[index] = editItemText.trim();
      }
      return { ...prev, [activeTab]: newList };
    });
    setEditingIndex(null);
  };

  const tabs = [
    { id: 'customerFields', label: 'Campos - Cliente' },
    { id: 'professorFields', label: 'Campos - Professor' },
    { id: 'clubs', label: 'Clubes / Condomínios' },
    { id: 'commissions', label: 'Comissão Professor (%)' },
    { id: 'strings', label: 'Corda (Main/Cross)' },
    { id: 'clubDiscounts', label: 'Desconto por Clube (%)' },
    { id: 'stringers', label: 'Encordoador' },
    { id: 'stringerAllocation', label: 'Alocação de Encordoadores' },
    { id: 'sports', label: 'Esporte' },
    { id: 'machines', label: 'Máquina de Encordoamento' },
    { id: 'racketModels', label: 'Modelos de Raquetes' },
    { id: 'pickupPoints', label: 'Ponto de Encordoamento' },
    { id: 'stringingPrices', label: 'Valor de Encordoamento' },
  ];

  
    const handleExportXLSX = () => {
    if (activeTab === 'strings') {
      const data = (settings.strings || []).map((s: any) => ({
        SKU: typeof s === 'string' ? '' : (s.sku || ''),
        Nome: typeof s === 'string' ? s : (s.name || ''),
        'Descrição Curta': typeof s === 'string' ? '' : (s.shortDescription || ''),
        Marca: typeof s === 'string' ? '' : (s.brand || ''),
        Tipo: typeof s === 'string' ? '' : (s.type || ''),
        Preço: typeof s === 'string' ? 0 : (s.price || 0)
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Cordas");
      XLSX.writeFile(workbook, "cordas.xlsx");
    } else if (activeTab === 'racketModels') {
      const data = (settings.racketModels || []).map((r: any) => ({
        Nome: typeof r === 'string' ? r : r.name || ''
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Raquetes");
      XLSX.writeFile(workbook, "modelos_raquetes.xlsx");
    }
  };

    const handleImportXLSX = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target?.result;
      const workbook = XLSX.read(bstr, { type: 'binary' });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const results: any[] = XLSX.utils.sheet_to_json(worksheet);

      if (activeTab === 'strings') {
        const parsed = results.map((row: any) => ({
          sku: row['SKU'] || '',
          name: row['Nome'] || '',
          shortDescription: row['Descrição Curta'] || row['Descricao Curta'] || '',
          brand: row['Marca'] || 'Desconhecida',
          type: row['Tipo'] || 'Monofilamento',
          price: Number(row['Preço'] || row['Preco']) || 0
        })).filter(s => s.name);
        
        setSettings((prev: any) => {
          const current = [...(prev.strings || [])];
          parsed.forEach(p => {
            const existingIdx = current.findIndex(c => 
               (typeof c === 'string' ? c === p.name : c.name === p.name) || 
               (c.sku && p.sku && c.sku === p.sku)
            );
            if (existingIdx !== -1) {
              current[existingIdx] = p; // update
            } else {
              current.push(p); // add
            }
          });
          return { ...prev, strings: current };
        });
      } else if (activeTab === 'racketModels') {
        const parsed = results.map((row: any) => ({
          name: row['Nome'] || ''
        })).filter(r => r.name);

        setSettings((prev: any) => {
          const current = [...(prev.racketModels || [])];
          parsed.forEach(p => {
            const existingIdx = current.findIndex(c => 
               typeof c === 'string' ? c === p.name : c.name === p.name
            );
            if (existingIdx !== -1) {
              current[existingIdx] = p;
            } else {
              current.push(p);
            }
          });
          return { ...prev, racketModels: current };
        });
      }
    };
    reader.readAsBinaryString(file);
  };

    return (

    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass-panel" style={{ padding: '24px', display: 'flex', gap: '32px' }}>
      
      {/* Sidebar / Tabs */}
      <div style={{ width: '250px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <h2 style={{ color: 'white', marginBottom: '16px', fontSize: '20px' }}>Configurações</h2>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            style={{
              padding: '12px 16px',
              borderRadius: '8px',
              border: 'none',
              background: activeTab === tab.id ? 'var(--primary-color)' : 'rgba(255,255,255,0.05)',
              color: activeTab === tab.id ? 'var(--text-dark)' : 'white',
              fontWeight: 600,
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.2s'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, background: 'rgba(0,0,0,0.2)', padding: '24px', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.1)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h3 style={{ color: 'white', fontSize: '18px', margin: 0 }}>
            Gerenciar: {tabs.find(t => t.id === activeTab)?.label}
          </h3>
          {(activeTab === 'strings' || activeTab === 'racketModels') && (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="text"
                placeholder={`Buscar ${activeTab === 'strings' ? 'corda' : 'raquete'}...`}
                value={searchQuery}
                onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white', width: '250px' }}
              />
              <button onClick={handleExportXLSX} style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', minWidth: '150px', whiteSpace: 'nowrap' }}>
                <Download size={16} /> Exportar XLSX
              </button>
              <label style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'var(--primary-color)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', margin: 0, minWidth: '150px', whiteSpace: 'nowrap' }}>
                <Upload size={16} /> Importar XLSX
                <input type="file" accept=".xlsx" onChange={handleImportXLSX} style={{ display: 'none' }} />
              </label>
            </div>
          )}
        </div>

        {activeTab === 'stringerAllocation' ? (
          <StringerAllocationSettings settings={settings} setSettings={setSettings} />
        ) : activeTab === 'customerFields' || activeTab === 'professorFields' ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ marginBottom: '16px', color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
              Configure a visibilidade e obrigatoriedade de cada campo no formulário de {activeTab === 'customerFields' ? 'clientes' : 'professores'}. As mudanças são salvas automaticamente.
            </div>
            {Object.entries(activeTab === 'customerFields' ? customerFieldLabels : professorFieldLabels).map(([key, label]) => (
              <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)' }}>
                <span style={{ color: 'white', fontWeight: 600, fontSize: '15px' }}>{label}</span>
                <select 
                  value={(settings[activeTab] && settings[activeTab][key]) || 'optional'}
                  onChange={(e) => {
                    const newVal = e.target.value;
                    setSettings((prev: any) => ({
                      ...prev,
                      [activeTab]: {
                        ...(prev[activeTab] || {}),
                        [key]: newVal
                      }
                    }));
                  }}
                  style={{ width: '200px', padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(0,0,0,0.5)', color: 'white' }}
                >
                  <option value="optional">Opcional</option>
                  <option value="mandatory">Obrigatório</option>
                  <option value="readonly">Apenas Exibição</option>
                  <option value="hidden">Oculto</option>
                </select>
              </div>
            ))}
          </div>
        ) : (
        <>
        {/* Add New */}
        <div style={{ display: 'flex', gap: '12px', marginBottom: '32px', flexWrap: 'wrap' }}>
          {activeTab === 'clubDiscounts' ? (
            <>
              <select value={newClub} onChange={(e) => setNewClub(e.target.value)} style={{ flex: 1, minWidth: '150px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}>
                 <option value="" disabled style={{ color: 'rgba(255,255,255,0.6)' }}>Selecione o clube...</option>
                 {[...(uniqueClubs as string[])].sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' })).map(c => <option key={c} value={c}>{c}</option>)}
              </select>
              <select value={newDiscountService} onChange={(e) => setNewDiscountService(e.target.value)} style={{ flex: 1, minWidth: '150px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}>
                 <option value="" disabled style={{ color: 'rgba(255,255,255,0.6)' }}>Selecione o serviço...</option>
                 <option value="Todos">Todos os serviços</option>
                 <option value="Encordoamento">Encordoamento</option>
                 <option value="Trocar grip base">Trocar grip base</option>
                 <option value="Trocar overgrip">Trocar overgrip</option>
                 <option value="Serviço customizado">Serviço customizado</option>
                 <option value="Compra de raquete nova">Compra de raquete nova</option>
                 <option value="Outros serviços">Outros serviços</option>
              </select>
              <input type="number" value={newDiscountPercent} onChange={(e) => setNewDiscountPercent(e.target.value)} placeholder="Desc. %" style={{ width: '80px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }} />
              <input type="number" value={newDiscountValue} onChange={(e) => setNewDiscountValue(e.target.value)} placeholder="Desc. BRL" style={{ width: '100px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }} />
              <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <input type="date" value={newStartDate} onChange={(e) => setNewStartDate(e.target.value)} style={{ width: '130px', padding: '12px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'rgb(148, 163, 184)' }} title="Data Início" />
                <span style={{ color: 'white' }}>-</span>
                <input type="date" value={newEndDate} onChange={(e) => setNewEndDate(e.target.value)} style={{ width: '130px', padding: '12px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'rgb(148, 163, 184)' }} title="Data Fim" />
              </div>
            </>
          ) : activeTab === 'commissions' ? (
            <select
              value={newItemText}
              onChange={(e) => setNewItemText(e.target.value)}
              style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
            >
              <option value="" disabled style={{ color: 'rgba(255,255,255,0.6)' }}>Selecione o serviço...</option>
              <option value="Encordoamento">Encordoamento</option>
              <option value="Trocar grip base">Trocar grip base</option>
              <option value="Trocar overgrip">Trocar overgrip</option>
              <option value="Serviço customizado">Serviço customizado</option>
              <option value="Compra de raquete nova">Compra de raquete nova</option>
              <option value="Outros serviços">Outros serviços</option>
            </select>
          ) : activeTab === 'stringingPrices' ? (
             <>
              <select
                value={newStringingPriceType}
                onChange={(e) => setNewStringingPriceType(e.target.value)}
                style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              >
                <option value="Multifilamento">1- Multifilamento</option>
                <option value="Monofilamento">2- Monofilamento</option>
                <option value="Tripa Natural">3- Tripa Natural</option>
              </select>
              <input 
                type="number" 
                value={newStringingPriceValue}
                onChange={(e) => setNewStringingPriceValue(e.target.value)}
                placeholder="Valor (BRL)"
                onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                style={{ width: '120px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
             </>
          ) : activeTab === 'stringers' ? (
             <>
              <input 
                type="text" 
                value={newItemText}
                onChange={(e) => setNewItemText(e.target.value)}
                placeholder="Nome do encordoador..."
                style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
              <input 
                type="email" 
                value={newStringerEmail}
                onChange={(e) => setNewStringerEmail(e.target.value)}
                placeholder="E-mail de acesso (opcional)"
                onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
             </>
          ) : (
            <input 
              type="text" 
              value={newItemText}
              onChange={(e) => setNewItemText(e.target.value)}
              placeholder={`Adicionar novo ${tabs.find(t => t.id === activeTab)?.label.toLowerCase()}...`}
              onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
              style={{ flex: 1, padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
            />
          )}

          {activeTab === 'commissions' && (
            <input 
              type="number" 
              value={newCommissionPercent}
              onChange={(e) => setNewCommissionPercent(e.target.value)}
              placeholder="Percentual (%)"
              onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
              style={{ width: '120px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
            />
          )}
          {activeTab === 'strings' && (
            <>
              <input 
                  type="text" 
                  value={newStringSku}
                  onChange={(e) => setNewStringSku(e.target.value)}
                  placeholder="SKU"
                  onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                  style={{ width: '100px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
                />
              <input 
                type="text" 
                value={newStringShortDescription}
                onChange={(e) => setNewStringShortDescription(e.target.value)}
                placeholder="Descrição Curta"
                onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                style={{ width: '150px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
              <input 
                type="text" 
                value={newStringBrand}
                onChange={(e) => setNewStringBrand(e.target.value)}
                placeholder="Marca"
                onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                style={{ width: '120px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
              <select
                value={newStringType}
                onChange={(e) => setNewStringType(e.target.value)}
                style={{ width: '180px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              >
                <option value="" disabled style={{ color: 'rgba(255,255,255,0.6)' }}>Tipo...</option>
                <option value="Multifilamento">1- Multifilamento</option>
                <option value="Monofilamento">2- Monofilamento</option>
                <option value="Tripa Natural">3- Tripa Natural</option>
              </select>
              <input 
                type="number" 
                value={newStringPrice}
                onChange={(e) => setNewStringPrice(e.target.value)}
                placeholder="Preço (BRL)"
                onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                style={{ width: '120px', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.05)', color: 'white' }}
              />
            </>
          )}
          <button onClick={handleAdd} style={{ padding: '0 24px', borderRadius: '8px', border: 'none', background: '#6FCF97', color: 'var(--text-dark)', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Plus size={18} /> Adicionar
          </button>
        </div>

        {/* List */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {currentList.length === 0 ? (
            <div style={{ padding: '24px', textAlign: 'center', color: 'rgba(255,255,255,0.5)' }}>Nenhum item cadastrado.</div>
          ) : (
            (() => {
              let renderList = currentList.map((item: any, idx: number) => ({ item, originalIndex: idx }));
              if ((activeTab === 'strings' || activeTab === 'racketModels') && searchQuery) {
                renderList = renderList.filter(({ item }: any) => {
                  const name = typeof item === 'string' ? item : item.name || '';
                  const short = typeof item === 'string' ? '' : item.shortDescription || '';
                  return name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(searchQuery.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) || short.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(searchQuery.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
                });
              }
              renderList.sort((a: any, b: any) => {
                let nameA = typeof a.item === 'string' ? a.item : (a.item.name || a.item.club || a.item.type || '');
                let nameB = typeof b.item === 'string' ? b.item : (b.item.name || b.item.club || b.item.type || '');
                return String(nameA).localeCompare(String(nameB), undefined, { sensitivity: 'base' });
              });
              const totalItems = renderList.length;
              const perPage = itemsPerPage === 'all' ? totalItems : itemsPerPage;
              const totalPages = Math.ceil(totalItems / perPage) || 1;
              const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * perPage;
              const endIndex = Math.min(startIndex + perPage, totalItems);
              const paginated = perPage === totalItems ? renderList : renderList.slice(startIndex, endIndex);

              return (
                <>
                  {paginated.map(({ item, originalIndex: idx }: { item: any; originalIndex: number }) => (
                    <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)' }}>
                  {editingIndex === idx ? (
                  <div style={{ display: 'flex', gap: '8px', flex: 1, marginRight: '16px', flexWrap: 'wrap' }}>
                    {activeTab === 'clubDiscounts' ? (
                      <>
                        <select value={editClub} onChange={(e) => setEditClub(e.target.value)} style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white' }}>
                          {[...(uniqueClubs as string[])].sort((a, b) => a.localeCompare(b, 'pt-BR', { sensitivity: 'base' })).map(c => <option key={c} value={c}>{c}</option>)}
                        </select>
                        <select value={editDiscountService} onChange={(e) => setEditDiscountService(e.target.value)} style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white' }}>
                           <option value="Todos">Todos os serviços</option>
                           <option value="Encordoamento">Encordoamento</option>
                           <option value="Trocar grip base">Trocar grip base</option>
                           <option value="Trocar overgrip">Trocar overgrip</option>
                           <option value="Serviço customizado">Serviço customizado</option>
                           <option value="Compra de raquete nova">Compra de raquete nova</option>
                           <option value="Outros serviços">Outros serviços</option>
                        </select>
                        <input type="number" value={editDiscountPercent} onChange={(e) => setEditDiscountPercent(e.target.value)} placeholder="%" style={{ width: '70px', padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white' }} />
                        <input type="number" value={editDiscountValue} onChange={(e) => setEditDiscountValue(e.target.value)} placeholder="BRL" style={{ width: '80px', padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white' }} />
                        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                          <input type="date" value={editStartDate} onChange={(e) => setEditStartDate(e.target.value)} style={{ width: '120px', padding: '8px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'rgb(148, 163, 184)' }} />
                          <span style={{ color: 'white' }}>-</span>
                          <input type="date" value={editEndDate} onChange={(e) => setEditEndDate(e.target.value)} style={{ width: '120px', padding: '8px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'rgb(148, 163, 184)' }} />
                        </div>
                      </>
                    ) : activeTab === 'commissions' ? (
                      <select
                        value={editItemText}
                        onChange={(e) => setEditItemText(e.target.value)}
                        style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                      >
                        <option value="Encordoamento">Encordoamento</option>
                        <option value="Trocar grip base">Trocar grip base</option>
                        <option value="Trocar overgrip">Trocar overgrip</option>
                        <option value="Serviço customizado">Serviço customizado</option>
                        <option value="Compra de raquete nova">Compra de raquete nova</option>
                        <option value="Outros serviços">Outros serviços</option>
                      </select>
                    ) : activeTab === 'stringingPrices' ? (
                      <select
                        value={editStringingPriceType}
                        onChange={(e) => setEditStringingPriceType(e.target.value)}
                        style={{ flex: 1, padding: '8px 12px', borderRadius: '6px', border: '1px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                      >
                        <option value="Multifilamento">1- Multifilamento</option>
                        <option value="Monofilamento">2- Monofilamento</option>
                        <option value="Tripa Natural">3- Tripa Natural</option>
                      </select>
                    ) : activeTab === 'stringers' ? (
                       <>
                          <input 
                            type="text"
                            value={editItemText}
                            autoFocus
                            onChange={(e) => setEditItemText(e.target.value)}
                            style={{ flex: 1, padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          />
                          <input 
                            type="email"
                            value={editStringerEmail}
                            onChange={(e) => setEditStringerEmail(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                            style={{ flex: 1, padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          />
                       </>
                    ) : (
                      <input 
                        type="text"
                        value={editItemText}
                        autoFocus
                        onChange={(e) => setEditItemText(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                        style={{ flex: 1, padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                      />
                    )}
                    {activeTab === 'commissions' && (
                      <input 
                        type="number"
                        value={editCommissionPercent}
                        onChange={(e) => setEditCommissionPercent(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                        style={{ width: '80px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                      />
                    )}
                    {activeTab === 'stringingPrices' && (
                      <input 
                        type="number"
                        value={editStringingPriceValue}
                        onChange={(e) => setEditStringingPriceValue(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                        style={{ width: '80px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                      />
                    )}
                    {activeTab === 'strings' && (
                      <>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label style={{ fontSize: '11px', color: '#FCD34D', fontWeight: 600 }}>SKU</label>
                          <input 
                            type="text"
                            value={editStringSku}
                            onChange={(e) => setEditStringSku(e.target.value)}
                            placeholder="SKU"
                            onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                            style={{ width: '100px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label style={{ fontSize: '11px', color: '#E5E7EB', fontWeight: 600 }}>Desc. Curta</label>
                          <input 
                            type="text"
                            value={editStringShortDescription}
                            onChange={(e) => setEditStringShortDescription(e.target.value)}
                            placeholder="Desc. Curta"
                            onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                            style={{ width: '140px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label style={{ fontSize: '11px', color: '#9CA3AF', fontWeight: 600 }}>Marca</label>
                          <input 
                            type="text"
                            value={editStringBrand}
                            onChange={(e) => setEditStringBrand(e.target.value)}
                            placeholder="Marca"
                            onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                            style={{ width: '100px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label style={{ fontSize: '11px', color: '#A78BFA', fontWeight: 600 }}>Tipo</label>
                          <select
                            value={editStringType}
                            onChange={(e) => setEditStringType(e.target.value)}
                            style={{ width: '140px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          >
                            <option value="Multifilamento">1- Multifilamento</option>
                            <option value="Monofilamento">2- Monofilamento</option>
                            <option value="Tripa Natural">3- Tripa Natural</option>
                          </select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <label style={{ fontSize: '11px', color: '#60A5FA', fontWeight: 600 }}>Preço (R$)</label>
                          <input 
                            type="number"
                            value={editStringPrice}
                            onChange={(e) => setEditStringPrice(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && saveEdit(idx)}
                            style={{ width: '80px', padding: '8px 12px', borderRadius: '4px', border: '1px solid var(--primary-color)', background: 'rgba(255,255,255,0.1)', color: 'white' }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flex: 1, paddingRight: '16px' }}>
                     {activeTab === 'stringingPrices' ? (
                       <>
                         <span style={{ color: 'white', fontWeight: 600, fontSize: '15px', flex: 1.5, minWidth: '150px' }}>
                           {item.type}
                         </span>
                         <span style={{ color: '#60A5FA', fontWeight: 500, fontSize: '14px', flex: 1 }}>
                           BRL {item.price ? item.price.toFixed(2) : '0.00'}
                         </span>
                       </>
                     ) : activeTab === 'strings' ? (
                       <>
                         <span style={{ color: 'white', fontWeight: 600, fontSize: '15px', flex: 1.5, minWidth: '150px' }}>
                           {typeof item === 'string' ? item : item.name}
                         </span>
                         <span style={{ color: '#FCD34D', fontWeight: 500, fontSize: '14px', flex: 0.6 }}>
                           {typeof item === 'string' ? '' : (item.sku || '-')}
                         </span>
                         <span style={{ color: '#E5E7EB', fontWeight: 500, fontSize: '14px', flex: 1 }}>
                           {typeof item === 'string' ? '' : item.shortDescription}
                         </span>
                         <span style={{ color: '#9CA3AF', fontWeight: 500, fontSize: '14px', flex: 0.8 }}>
                           {typeof item === 'string' ? 'Desconhecida' : (item.brand || 'Desconhecida')}
                         </span>
                         <span style={{ color: '#A78BFA', fontWeight: 500, fontSize: '14px', flex: 1 }}>
                           {typeof item === 'string' ? '' : item.type}
                         </span>
                         <span style={{ color: '#60A5FA', fontWeight: 500, fontSize: '14px', flex: 1 }}>
                           BRL {typeof item === 'string' ? '0.00' : item.price.toFixed(2)}
                         </span>
                       </>
                     ) : activeTab === 'commissions' ? (
                       <>
                         <span style={{ color: 'white', fontWeight: 600, fontSize: '15px', flex: 1.5, minWidth: '150px' }}>
                           {typeof item === 'string' ? item : item.name}
                         </span>
                         <span style={{ color: '#F2C94C', fontWeight: 700, fontSize: '14px', flex: 1 }}>
                           {item.percent}%
                         </span>
                       </>
                     ) : activeTab === 'clubDiscounts' ? (
                       <>
                         <span style={{ color: 'white', fontWeight: 600, fontSize: '15px', flex: 1.2, minWidth: '120px' }}>
                           {item.club}
                         </span>
                         <span style={{ color: '#9CA3AF', fontWeight: 500, fontSize: '14px', flex: 1.5, minWidth: '150px' }}>
                           {item.service}
                         </span>
                         <span style={{ color: '#6FCF97', fontWeight: 700, fontSize: '14px', flex: 0.6 }}>
                           {item.percent ? `-${item.percent}%` : ''} {item.value ? `(BRL -${item.value})` : ''}
                         </span>
                         <span style={{ color: '#A78BFA', fontWeight: 500, fontSize: '14px', flex: 1.5 }}>
                           {item.startDate ? `${item.startDate.split('-').reverse().join('/')} até ${item.endDate.split('-').reverse().join('/')}` : 'Sempre'}
                         </span>
                       </>
                     ) : activeTab === 'stringers' ? (
                       <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                         <span style={{ color: 'white', fontWeight: 600, fontSize: '15px' }}>
                           {typeof item === 'string' ? item : item.name}
                         </span>
                         {(typeof item !== 'string' && item.email) && (
                           <span style={{ color: '#9CA3AF', fontSize: '13px', marginTop: '4px' }}>
                             {item.email}
                           </span>
                         )}
                       </div>
                     ) : (
                       <span style={{ color: 'white', fontWeight: 500, fontSize: '15px' }}>
                         {item}
                       </span>
                     )}
                  </div>
                )}
                
                <div style={{ display: 'flex', gap: '8px' }}>
                  {editingIndex === idx ? (
                    <button onClick={() => saveEdit(idx)} style={{ background: '#6FCF97', border: 'none', color: 'var(--text-dark)', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600 }}>
                      Salvar
                    </button>
                  ) : (
                    <button onClick={() => handleEdit(idx)} style={{ background: '#4298E7', border: 'none', color: 'white', padding: '8px', borderRadius: '6px', cursor: 'pointer', display: 'flex' }}>
                      <Edit size={16} />
                    </button>
                  )}
                  <button onClick={() => handleDelete(idx)} style={{ background: '#EB5757', border: 'none', color: 'white', padding: '8px', borderRadius: '6px', cursor: 'pointer', display: 'flex' }}>
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
              <div style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#6B7280', fontSize: '13px', background: 'white', borderRadius: '8px', marginTop: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>Show</span>
                  <select value={itemsPerPage} onChange={(e) => { setItemsPerPage(e.target.value === 'all' ? 'all' : parseInt(e.target.value)); setCurrentPage(1); }} style={{ padding: '4px 8px', borderRadius: '4px', border: '1px solid #E5E7EB', background: '#F8F9FA' }}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                    <option value="all">Todas</option>
                  </select>
                  <span>entries</span>
                  <span style={{ marginLeft: '16px' }}>Showing {totalItems === 0 ? 0 : startIndex + 1} to {endIndex} of {totalItems} entries</span>
                </div>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1} style={{ border: 'none', background: 'none', color: currentPage === 1 ? '#9CA3AF' : '#4298E7', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', fontWeight: 600 }}>Previous</button>
                  <button style={{ border: 'none', background: '#4298E7', color: 'white', width: '28px', height: '28px', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>{currentPage}</button>
                  <button onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages} style={{ border: 'none', background: 'none', color: currentPage === totalPages ? '#9CA3AF' : '#4298E7', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', fontWeight: 600 }}>Next</button>
                </div>
              </div>
            </>
          );
          })()
          )}
        </div>
        </>
        )}

      </div>
    </motion.div>
  );
};
